import { render, staticRenderFns } from "./VideonChart.vue?vue&type=template&id=0bc20491&scoped=true"
import script from "./VideonChart.vue?vue&type=script&lang=js"
export * from "./VideonChart.vue?vue&type=script&lang=js"
import style0 from "./VideonChart.vue?vue&type=style&index=0&id=0bc20491&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc20491",
  null
  
)

export default component.exports